import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { useFetchAttendanceBalanceBreakdowns } from 'modules/attendance/hooks/useFetchAttendanceBalanceBreakdown'
import { STATUS } from 'modules/attendance/lib/enums'
import overtimeRequestsCollection from 'modules/attendance/store/collections/overtimeRequests'
import attendanceSettings from 'modules/attendance/store/collections/settings'

interface Props {
  employeeIds: number[]
  isMonthly: boolean
  from: string
  to: string
  compensatedEmployeeIds: number[]
  compensatedAt: string
}

const useData = ({
  employeeIds,
  isMonthly,
  from,
  to,
  compensatedEmployeeIds,
  compensatedAt,
}: Props) => {
  const {
    loading: loadingBreakdowns,
    balanceBreakdowns: breakdowns,
    refetch: refetchBreakdowns,
  } = useFetchAttendanceBalanceBreakdowns(
    { employeeIds: employeeIds, date: to },
    { skip: !isMonthly }
  )

  const { loading } = useAsyncData(() => {
    if (!employeeIds.length) return Promise.resolve()

    const fetches = [
      attendanceSettings.fetch({
        data: {
          employee_ids: employeeIds,
          start_on: from,
          end_on: to,
        },
      }),
      overtimeRequestsCollection.fetch({
        data: {
          employee_ids: employeeIds,
          start_on: from,
          end_on: to,
          status: STATUS.approved,
        },
      }),
    ]

    if (isMonthly) {
      refetchBreakdowns({
        employeeIds: employeeIds,
        date: to,
      })
    }

    return Promise.all(fetches)
  }, [employeeIds.join(), isMonthly, from, to])

  useAsyncData(() => {
    if (!compensatedEmployeeIds.length) return Promise.resolve()

    return refetchBreakdowns({
      employeeIds: compensatedEmployeeIds,
      date: to,
    })
  }, [compensatedEmployeeIds.join(), compensatedAt])

  return {
    loading: loading || loadingBreakdowns,
    attendanceSettings,
    overtimeRequestsCollection,
    breakdowns,
  }
}

export default useData
